import React, { useEffect, useState } from 'react'
import Slides from '../slides/Slides'
import axios from 'axios';
import Modal from './Modal';
import { WebService } from '../../services/webService';
import Swal from 'sweetalert2';

const Blog = ({M}) => {
   const [blogWhite,setBlogWhite]   = useState();
   const [blogBlue, setBlogBlue]    = useState();
   const [blogMonth, setBlogMonth]  = useState();
   const [modal, setModal]          = useState();
   
   const getBlog = async () => {
      try {
         const data = await WebService.getBlog();
         setBlogWhite(data.blogWhite || []);
         setBlogBlue(data.blogBlue || []);
         setBlogMonth(data.blogMonth || []);
      } catch (error) {
         Swal.fire({
            icon: "error",
            title: "Error!",
            text: "No se pudieron cargar los datos del blog",
            confirmButtonColor: "#147B9C",
         });
      }
   };

   const handleModalBlog = async (blog_id) => {
   try {
      const data = await WebService.getBlogByID(blog_id);
      setModal(data);
   } catch (error) {
      Swal.fire({
         icon: "error",
         title: "Error!",
         text: "No se pudo cargar la información del blog",
         confirmButtonColor: "#147B9C",
      });
   }
   };

   useEffect(() => {
      getBlog();
      let collapsible = document.querySelectorAll(".collapsible");
      M.Collapsible.init(collapsible);

      let modal = document.querySelectorAll(".modal-blog");
      M.Modal.init(modal);
   }, []);
   return (
      <>
         <Slides M={M} tipoSlides={"blog"}/>
         <div className="section animated fadeIn">
            <div className="row">
               <div className="col s12 m12 l8 xl8">
                  <div className="scroll">
                     {blogWhite?.map((bw,index) => {
                        return (
                           <div className="card horizontal">
                              <div className="card-image">
                                 <img src={`/app.latitud/img/blog/${bw.blog_img}`} alt={bw.blog_titulo}/>
                                 <p><strong className="etiqueta">{bw.blog_etiqueta}</strong></p>
                              </div>
                              <div className="card-stacked">
                                 <div className="card-content">
                                    <h5>{bw.blog_titulo}</h5>
                                    <p><div dangerouslySetInnerHTML={{__html:bw.blog_texto_breve}}></div></p>
                                 </div>
                                 <div className="card-action">
                                    <a className="modal-trigger"  href="#modalBlog" onClick={()=>handleModalBlog(bw.blog_id)}>Leer más</a>
                                    <span className="float-right">{bw.blog_fecha}</span>
                                 </div>
                              </div>
                           </div>
                        )
                     })}
                  </div>
               </div>
               <div className="col s12 m12 l4 xl4 bg-latitud">
                  <div className="scroll-res">
                     {blogBlue?.map((bb,index) => {
                        return (
                           <div className="card">
                              <div className="card-image">
                                 <img src={`/app.latitud/img/blog/${bb.blog_img}`} alt={bb.blog_img}/>
                                 <a className="btn-floating btn-large halfway-fab waves-effect waves-light bg-latitud modal-trigger" href="#modalBlog" onClick={()=>handleModalBlog(bb.blog_id)}><i className="material-icons">visibility</i></a>
                              </div>
                              <div className="card-content">
                                 <span className="card-title"><strong>{bb.blog_titulo}</strong></span>
                                 <span className="float-right">{bb.blog_fecha}</span>
                              </div>
                              <div className="card-action">
                                 <span className="etiqueta">{bb.blog_etiqueta}</span>
                              </div>
                           </div>
                        )
                     })}
                  </div>
                  <div className="container">
                     <ul className="collapsible">
                        {
                           blogMonth?.map((bm,index) => {
                              return(
                                 <li>
                                    <div className="collapsible-header"><strong>{bm.nombreMes}</strong><span className="new badge blue">{bm.cantidad}</span></div>
                                    {
                                       bm?.news?.map((n,index)=>{
                                          return(
                                             <div className="collapsible-body"><span><a className="text-white modal-trigger" href="#modalBlog" onClick={()=>handleModalBlog(n.blog_id)}>{n.blog_titulo}</a></span></div>
                                          )
                                       })
                                    }
                                 </li>
                              )
                           })
                        }
                     </ul>
                  </div>
               </div>
            </div>
         </div>
         <Modal modal={modal}/>
      </>
   )
}

export default Blog